import styled from '@emotion/styled';
import { Table as BSTable } from 'react-bootstrap';

export const FlexDiv = styled.div`
  display: flex;
`;

export const FlexDivSpaceBetween = styled(FlexDiv)`
  justify-content: space-between;
`;

export const FlexJustifyCenter = styled(FlexDiv)`
  justify-content: center;
`;

export const FlexJustifyRight = styled(FlexDiv)`
  justify-content: right;
`;

export const FlexAlignCenter = styled(FlexDiv)`
  align-items: center;
`;

export const FlexCenter = styled(FlexJustifyCenter)`
  align-items: center;
`;

export const FlexDivSpaceBetweenCenter = styled(FlexDivSpaceBetween)`
  align-items: center;
`;

export const FlexDivSpaceBetweenCenterShrink = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.5rem;
  width: 100%;
  min-width: 0;
`;

export const FlexWrap = styled(FlexDiv)`
  flex-wrap: wrap;
`;

export const FlexColumn = styled(FlexDiv)`
  flex-direction: column;
`;

export const FlexColumnCenterAlign = styled(FlexColumn)`
  align-items: center;
`;

export const FlexColumnCenter = styled(FlexColumn)`
  align-items: center;
  justify-content: center;
`;

export const FixedTable = styled(BSTable)`
  table-layout: fixed;
  width: 100%;
  min-width: 100%;
  max-width: none;

  &.fixed-table {
    margin-bottom: 0;
  }

  th,
  td {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  td .cell-content {
    display: block;
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  thead th .th-inner {
    display: flex;
    align-items: center;
    gap: 0.25rem;
    width: 100%;
    min-width: 0;
  }

  thead th .label {
    min-width: 0;
    flex: 1 1 auto;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  thead th .sort-slot {
    width: 1em;
    flex: 0 0 1em;
    display: inline-block;
  }
`;

export const TableScrollContainer = styled.div`
  width: 100%;
  max-width: 100%;
  min-width: 0;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
`;
